export const shouldHandleAuthenticationRedirect = () =>
  window.location.href.includes('code') ||
  window.location.href.includes('error');
